interface Props {
    title?: string;
    description?: string;
    height?: string;
}

export default function TableEmpty({
    title = 'No records found',
    description = 'There are currently no records available.',
    height = 'min-h-[320px]',
}: Props) {
    return (
        <tr>
            <td className="p-0" colSpan={999}>
                <div className={`flex w-full ${height} items-center justify-center px-4`}>
                    <div className="flex flex-col items-center justify-center text-center">
                        <div className="flex h-8 w-8 items-center justify-center rounded-full border border-[#186cb2]/10 bg-[#186cb2]/10 text-[#186cb2]">
                            <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
                                <path d="M6 3.75h8.25L18.5 8v12.25H6V3.75Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                                <path d="M14 3.75V8h4.25" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
                                <path d="M9 12h6M9 15h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            </svg>
                        </div>
                        <div className="mt-3">
                            <p className="text-xs font-medium text-gray-800">{title}</p>
                            <p className="mt-0.5 text-xs text-gray-400">{description}</p>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    );
}